import { TransfersOtherBanksEventType } from './../transfers-other-banks.event.type';
import { Bank } from './../../models/banks';
import { TransfersOtherBanksService } from './../transfers-other-banks.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Ownership } from '../models/ownership';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { Auth } from './../../../autentication/Auth';
import { Transfer } from '../../models/transfer';
import { Modality } from '../models/modality';
import { BenefactorDataModel } from '../../models/benefactorData';
import { EventTypes } from '../../../shared/EventTypes';
import { MatTableDataSource, MatSort } from '@angular/material';
import { Util } from '../../../utils/util';

@Component({
	selector: 'app-favored-data',
	templateUrl: './favored-data.component.html',
	styleUrls: ['./favored-data.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class FavoredDataComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;

	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	public agency = '';

	public form: FormGroup;
	private view = '[data-component="favored-data"]';

	private banks: Array<Bank> = [];
	public modalities: Array<Modality> = [];
	public filteredBanks: Observable<Bank[]>;
	public ownerships: Array<Ownership> = [];
	private viewHeight = 0;
	public hideDestinationAgency: boolean = false;

	active = false;

	cpfcnpj;
	cpfcnpjOld;

	destinationAccount;
	destinationAccountOld;

	favoredSelected;

	dataSource: MatTableDataSource<BenefactorDataModel>;
	displayedColumns = ['name', 'cpf', 'bank', 'agency', 'account', 'modality', 'check'];
	isLoadingBenefactors = true;



	// (^\d{3}\x2E\d{3}\x2E\d{3}\x2D\d{2}$)|(^\d{2}.\d{3}.\d{3}/\d{4}-\d{2}$)

	constructor(private formBuilder: FormBuilder, private transferOBService: TransfersOtherBanksService) {

		this.form = formBuilder.group({
			'bank': [null, Validators.required],
			'modality': [null, Validators.required],
			'destinationAgency': [null, Validators.required],
			'destinationAccount': [null, Validators.required],
			'ownership': [1, Validators.required],
			'favoredName': [null],
			'favoredCpfCnpj': [null],
			'remember': [false],
			'favoredSelect': [null]
		});
		this.modalities = [new Modality('CC', 'Conta Corrente'), new Modality('PP', 'Conta Poupança')];
		this.ownerships = [new Ownership(1, 'Mesma Titularidade'), new Ownership(2, 'Outra Titularidade')];

	}

	ngOnInit() {
		this.form.controls.modality.setValue('CC');

		AppEventDispatcher.listen(TransfersOtherBanksEventType.STEPS.FAVORED_DATA, data => {

			if (data.show) {
				this.setForm.emit(this.form);
				this.show();
			} else {
				this.hide();
			}
		});

		this.transferOBService.getBanks().subscribe(data => {

			this.banks = data;
			this.filteredBanks = this.form.controls.bank.valueChanges.pipe(
				startWith({} as Bank),
				map(bank => bank && typeof bank === 'object' ? bank.label : bank),
				map(label => label ? this.filter(label) : this.banks.slice())
			);

		});

		this.getBenefactors();

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.STEPS.FAVORED_DATA);
	}

	show() {
		this.active = true;

		if (this.transferData.transferType === 'TED') {
			this.modalities.push(new Modality('PG', 'Conta Pagamento'));
		}
		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			this.viewHeight = containerHeight;

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
		});
	}

	validateBank(e) {
		if (e.source !== undefined) {
			this.form.controls['bank'].setErrors(null);
		} else {
			this.form.controls['bank'].setErrors({ 'incorrect': true });
		}
	}

	hide() {
		if (!this.favoredSelected) {
			this.setTransferData();
		} else {
			this.setTransferDataWithFavoredSelected();
		}

		TweenMax.to(this.view, 1, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});
	}

	getBenefactors() {
		this.transferOBService.getBenefactors().subscribe(dados => {
			this.dataSource = new MatTableDataSource(dados);
			this.isLoadingBenefactors = false;
		}, error => {
			this.isLoadingBenefactors = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	setTransferData() {
		this.transferData.bankCode = this.form.controls.bank.value.code;
		this.transferData.bankDesc = this.form.controls.bank.value.name;
		this.transferData.modality = this.form.controls.modality.value;
		this.transferData.destinationAgency = this.form.controls.destinationAgency.value;
		this.transferData.destinationAccount = this.form.controls.destinationAccount.value.replace(/\D/g, '');
		this.transferData.ownership = this.ownerships[this.form.controls.ownership.value - 1].name;
		this.transferData.favoredRemember = this.form.controls.remember.value;

		if (this.form.controls.favoredName.value) {
			this.transferData.favoredName = this.form.controls.favoredName.value;
		} else {
			this.transferData.favoredName = Auth.getInstance().getUser().name;
		}

		if (this.form.controls.favoredCpfCnpj.value) {
			this.transferData.favoredCpfCnpj = Util.removeMaskCharacters(this.form.controls.favoredCpfCnpj.value);
		} else {
			this.transferData.favoredCpfCnpj = Auth.getInstance().getUser().cpfCnpj;
		}
	}

	setTransferDataWithFavoredSelected() {
		this.transferData.bankCode = this.favoredSelected.bankCode;
		this.transferData.bankDesc = this.favoredSelected.bankDesc;
		this.transferData.modality = this.favoredSelected.modality;
		this.transferData.destinationAgency = this.favoredSelected.agency.toString();
		this.transferData.destinationAccount = this.favoredSelected.accountNumber.replace(/\D/g, '');
		this.transferData.favoredRemember = false;
		this.transferData.ownership = (Auth.getInstance().getUser().cpfCnpj.toUpperCase() === Util.removeMaskCharacters(this.favoredSelected.cpfCnpj).toUpperCase()) ? this.ownerships[0].name : this.ownerships[1].name;

		this.transferData.favoredName = this.favoredSelected.name;
		this.transferData.favoredCpfCnpj = Util.removeMaskCharacters(this.favoredSelected.cpfCnpj);

	}

	filter(val): Bank[] {
		return this.banks.filter(bank => bank.label.includes(val));
	}

	autoCompleteDisplay(bank: Bank): any {
		return bank ? bank.label : bank;
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight();
	}

	checkModality(value) {
		let containerHeight: number;

		if (value === 'PG') {
			containerHeight = this.getStepHeight() - 80;
			this.hideDestinationAgency = true;
			this.form.controls.destinationAgency.clearValidators();
			this.form.controls.destinationAgency.updateValueAndValidity();
		} else {
			containerHeight = this.viewHeight;
			this.hideDestinationAgency = false;
			this.form.controls.destinationAgency.setValidators(Validators.required);
			this.form.controls.destinationAgency.updateValueAndValidity();
		}
		TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
	}

	checkOwnership(value) {
		let containerHeight: number;

		if (value === 2) {
			containerHeight = this.getStepHeight() + 160;
			this.form.controls.favoredName.setValidators(Validators.required);
			this.form.controls.favoredName.updateValueAndValidity();
			this.form.controls.favoredCpfCnpj.setValidators([Validators.required, Validators.minLength(14)]);
			this.form.controls.favoredCpfCnpj.updateValueAndValidity();
		} else {
			containerHeight = this.viewHeight;
			this.form.controls.favoredName.clearValidators();
			this.form.controls.favoredName.updateValueAndValidity();
			this.form.controls.favoredCpfCnpj.clearValidators();
			this.form.controls.favoredCpfCnpj.updateValueAndValidity();
		}
		TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
	}

	showTab(tab) {
		let containerHeight: number;
		if (tab.index === 1) {
			containerHeight = this.getStepHeight() + 30;
			this.form.controls.favoredSelect.setValidators(Validators.required);
			this.form.controls.favoredSelect.updateValueAndValidity();

			this.form.controls.bank.clearValidators();
			this.form.controls.bank.updateValueAndValidity();

			this.form.controls.destinationAgency.clearValidators();
			this.form.controls.destinationAgency.updateValueAndValidity();

			this.form.controls.destinationAccount.clearValidators();
			this.form.controls.destinationAccount.updateValueAndValidity();

		} else {
			containerHeight = this.viewHeight;

			this.favoredSelected = null;

			this.form.controls.favoredSelect.clearValidators();
			this.form.controls.favoredSelect.updateValueAndValidity();

			this.form.controls.bank.setValidators(Validators.required);
			this.form.controls.bank.updateValueAndValidity();

			this.form.controls.modality.setValidators(Validators.required);
			this.form.controls.modality.updateValueAndValidity();

			this.form.controls.destinationAgency.setValidators(Validators.required);
			this.form.controls.destinationAgency.updateValueAndValidity();

			this.form.controls.destinationAccount.setValidators(Validators.required);
			this.form.controls.destinationAccount.updateValueAndValidity();

			this.form.controls.ownership.setValue(1);

		}
		TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
	}

	changeFavored() {
		this.favoredSelected = this.form.controls.favoredSelect.value;
	}

	applyFilter(filterValue: string) {
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}

	cpfcnpjKeydown(event: KeyboardEvent) {
		Util.handleCpfCnpjKeydown(event);
	}

	cpfcnpjMask(event) {
		if (event.keyCode === 8) {
		} else if (event.target.value.length <= 19) {
			const raw = Util.removeMaskCharacters(event.target.value);
			const newVal = Util.maskCpfCnpj(raw);

			if (Util.hasLetters(raw) || raw.length > 11) {
				this.form.controls.favoredCpfCnpj.setValidators([Validators.required, Validators.minLength(18)]);
			} else {
				this.form.controls.favoredCpfCnpj.setValidators([Validators.required, Validators.minLength(14)]);
			}
			this.form.controls.favoredCpfCnpj.updateValueAndValidity();

			this.cpfcnpjOld = this.cpfcnpj = newVal;
		} else {
			this.cpfcnpj = this.cpfcnpjOld;
		}
	}

	maskCpfCpnj(cpfCnpj: string): string{
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	destinationAccountMask(event) {
		if (event.keyCode === 8) {
		} else if (event.target.value.length <= 21) {
			// remove all mask characters (keep only numeric)
			let newVal = event.target.value.replace(/\D/g, '');


			// don't show braces for empty value
			if (newVal.length === 0) {
				newVal = '';
			} else {
				newVal = newVal.replace(/^(\d{0,20})*(\d{1})/, '$1-$2');
			}

			// set the new value
			this.destinationAccountOld = this.destinationAccount = newVal;
		} else {
			this.destinationAccount = this.destinationAccountOld;
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/favored-data/favored-data.component.ts